export var ItemType = /*#__PURE__*/function (ItemType) {
  ItemType["Project"] = "PROJECT";
  ItemType["Folder"] = "FOLDER";
  ItemType["Document"] = "DOCUMENT";
  ItemType["Link"] = "LINK";
  ItemType["Client"] = "CLIENT";
  ItemType["Template"] = "TEMPLATE";
  ItemType["AppGroup"] = "APP_GROUP";
  ItemType["YearGroup"] = "YEAR_GROUP";
  ItemType["Trash"] = "TRASH";
  return ItemType;
}({});
var values = Object.values(ItemType);
export function isItemType(str) {
  return values.includes(str);
}
export function stringToItemType(str) {
  if (isItemType(str)) {
    return str;
  }
  throw new Error("Invalid item type: \"".concat(str, "\""));
}
